// extracted by mini-css-extract-plugin
export var wordContainer = "_nb-0";